<template>
  <multiselect
    v-bind="$attrs"
    v-on="$listeners"
    selectLabel=""
    selectedLabel="Activo"
    :label="label"
    :value="value"
    :options="options"
    :disabled="disabled"
    :placeholder="placeholder"
    :deselectLabel="deselectLabel"
  >
    <template #noResult>No se ha encontrado ningún elemento</template>
    <template #noOptions>No hay opciones...</template>
  </multiselect>
</template>

<script>
// Components
import Multiselect from 'vue-multiselect'

export default {
  name: 'AppMultiselect',

  components: {
    Multiselect,
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [Object, String, Number, Array],
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    deselectLabel: {
      type: String,
      default: 'Eliminar',
    },
    label: {
      type: String,
      default: '',
    },
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
